<!-- add user dialog -->
<div
  class="add-user"
  *ngIf="data?.type === 'add_user' || data?.type === 'edit_user'"
>
  <form [formGroup]="addUserFromGroup">
    <div class="form-field row" *ngIf="data?.type === 'edit_user'">
      <div class="input-group py-2 col">
        <label class="w-100 mb-2" for="">{{ 'ADMIN.FIRST_NAME' | translate }}</label><br />
        <input
          type="text"
          class="form-control"
          [placeholder]="'ADMIN.ENTER_NAME' | translate"
          formControlName="fname"
          readonly
        />
      </div>
      <div class="input-group py-2 col">
        <label class="w-100 mb-2" for="">{{ 'ADMIN.LAST_NAME' | translate }}</label><br />
        <input
          type="text"
          class="form-control"
          [placeholder]="'ADMIN.ENTER_NAME' | translate"
          formControlName="lname"
          readonly
        />
      </div>
    </div>

    <div class="form-field">
      <div class="input-group" *ngIf="data?.type === 'add_user'">
        <label class="w-100 mb-2" for="">{{ 'ADMIN.EMAIL' | translate }}</label><br />
        <input
          type="text"
          class="form-control"
          [placeholder]="'ADMIN.SELECT_EMAIL' | translate"
          formControlName="email"
        />
        <i class="pi pi-info-circle"></i>
      </div>
      <p
        class="error-text"
        *ngIf="
          data?.type === 'add_user' &&
          checkError('email', 'required') &&
          isFormSubmitted
        "
      >
        {{ 'ADMIN.EMAIL_REQUIRED' | translate }}
      </p>
      <p
        class="error-text"
        *ngIf="
          data?.type === 'add_user' &&
          checkError('email', 'email') &&
          isFormSubmitted
        "
      >
        {{ 'ADMIN.EMAIL_NOT_VALID' | translate }}
      </p>
    </div>

    <div class="form-field">
      <div class="input-group py-2" *ngIf="data?.type === 'edit_user'">
        <label class="w-100 mb-2" for="">{{ 'ADMIN.EMAIL' | translate }}</label><br />
        <input
          type="text"
          class="form-control"
          [placeholder]="'ADMIN.SELECT_EMAIL' | translate"
          formControlName="email"
          readonly
        />
      </div>
    </div>

    <div class="form-field">
      <div class="input-group py-2" *ngIf="data?.type === 'add_user'">
        <label class="w-100 mb-2" for="">{{ 'ADMIN.ZONE' | translate }}</label><br />
        <p-dropdown
          appendTo="body"
          [options]="data?.zones"
          optionLabel="name"
          optionValue="id"
          [placeholder]="'ADMIN.SELECT_ZONE' | translate"
          styleClass="add-user-dropdown"
          panelStyleClass="add-user-dropdown-panel"
          formControlName="zone"
        ></p-dropdown>
        <p class="error-text" *ngIf="checkError('zone', 'required')">
          {{ 'ADMIN.PLEASE_SELECT_ZONE' | translate }}
        </p>
      </div>
    </div>
    <div class="py-2" *ngIf="data?.type === 'edit_user'">
      <label class="w-100 mb-2" for="">{{ 'ADMIN.BETA_USER' | translate }}</label><br />
      <span style="margin-right: 10px">
        <input
          type="radio"
          name="beta_user"
          [value]="true"
          formControlName="beta_user"
        />
        <span
          style="
            margin-left: 5px;
            font: normal normal normal 14px/19px Open Sans;
          "
          >{{ 'SHARED.YES' | translate }}</span>
      </span>
      <span>
        <input
          formControlName="beta_user"
          type="radio"
          name="beta_user"
          [value]="false"
        />
        <span
          style="
            margin-left: 5px;
            font: normal normal normal 14px/19px Open Sans;
          "
          >{{ 'SHARED.NO' | translate }}</span>
      </span>
    </div>
    <div class="input-group py-2" *ngIf="data?.editMode === 'true'">
      <label class="w-100 mb-2" for="">{{ 'ADMIN.STATUS' | translate }}</label><br />
      <p-dropdown
        [options]="status"
        [placeholder]="'ADMIN.SELECT_STATUS' | translate"
        optionName="label"
        optionValue="value"
        styleClass="add-user-dropdown"
        panelStyleClass="roles-dropdown-panel"
        formControlName="status"
      ></p-dropdown>
    </div>
  </form>
</div>
<!-- revoke zone access -->
<div class="revoke-key-account" *ngIf="data?.type === 'revoke_zone'">
  <div class="confirm-message">
    {{ 'ADMIN.REVOKE_ZONE_MSG_1' | translate }} <b>{{ data?.rowData?.email }}</b> {{ 'ADMIN.REVOKE_ZONE_MSG_2' | translate }} <b>{{ data?.currentZone?.name }}</b> {{ 'ADMIN.REVOKE_ZONE_MSG_3' | translate }}
  </div>
</div>

<!-- revoke user profile zone access -->
<div class="revoke-key-account" *ngIf="data?.type === 'revoke_zone_access'">
  <div class="confirm-message">
    {{ 'ADMIN.REVOKE_ZONE_ACCESS_MSG_1' | translate }} <b>{{ data?.activeZone?.name }}</b> {{ 'ADMIN.REVOKE_ZONE_ACCESS_MSG_2' | translate }}
  </div>
</div>

<!-- revoke user profile KA access -->
<div
  class="revoke-key-account"
  *ngIf="data?.type === 'revoke_key_account_access'"
>
  <div class="confirm-message">
    {{ 'ADMIN.REVOKE_KA_MSG_1' | translate }} <b>{{ data?.rowData?.name }}</b> {{ 'ADMIN.REVOKE_KA_MSG_2' | translate }}
  </div>
</div>

<!-- migrate user -->
<div class="revoke-key-account" *ngIf="data?.type === 'migrate_user'">
  <div class="confirm-message">
    {{ 'ADMIN.MIGRATE_USER_MSG_1' | translate }} <b>{{ data?.rowData?.email }}</b> {{ 'ADMIN.MIGRATE_USER_MSG_2' | translate }} <b>{{ data?.currentZone?.name }}</b> {{ 'ADMIN.MIGRATE_USER_MSG_3' | translate }}
  </div>
  <div class="input-group py-2">
    <label class="w-100 mb-2" for="">{{ 'ADMIN.ZONE' | translate }}</label><br />
    <p-dropdown
      appendTo="body"
      [options]="data?.zones"
      optionLabel="name"
      optionValue="id"
      [placeholder]="'ADMIN.SELECT' | translate"
      styleClass="add-user-dropdown"
      panelStyleClass="add-user-dropdown-panel"
      [(ngModel)]="selectedZoneId"
    ></p-dropdown>
    <div *ngIf="!selectedZoneId && isFormSubmitted" class="error-form-field">
      <p>{{ 'ADMIN.PLEASE_SELECT_ZONE' | translate }}</p>
    </div>
  </div>
</div>

<!-- request zone -->
<div class="revoke-key-account" *ngIf="data?.type === 'request_zone'">
  <div class="input-group py-1">
    <label class="w-100 mb-2" for="">{{ 'ADMIN.ZONE' | translate }}</label><br />
    <p-dropdown
      appendTo="body"
      [options]="data?.zones"
      optionLabel="name"
      optionValue="id"
      [placeholder]="'ADMIN.SELECT' | translate"
      styleClass="add-user-dropdown"
      panelStyleClass="add-user-dropdown-panel"
      [(ngModel)]="selectedZoneId"
    ></p-dropdown>
    <div *ngIf="!selectedZoneId && isFormSubmitted" class="error-form-field">
      <p>{{ 'ADMIN.PLEASE_SELECT_ZONE' | translate }}</p>
    </div>
  </div>
</div>

<!--add zone-->
<div class="system-add-zone" *ngIf="data?.type === 'system_request_zone'">
  <div class="input-group py-1">
    <label class="w-100 mb-2" for="">{{ 'ADMIN.ZONE' | translate }}</label><br />
    <input
      [placeholder]="'ADMIN.ZONE_NAME' | translate"
      type="text"
      class="form-control"
      [(ngModel)]="selectedZoneId"
    />
  </div>
  <div *ngIf="!selectedZoneId && isFormSubmitted" class="error-form-field">
    <p>{{ 'ADMIN.ZONE_NAME_REQUIRED' | translate }}</p>
  </div>
</div>

<!-- request key account access from user profile page -->
<div class="add-edit-key-account" *ngIf="data?.type === 'request_key_account'">
  <div class="search-input-group">
    <input
      [placeholder]="'ADMIN.SEARCH_KA_PLACEHOLDER' | translate"
      class="form-control"
      type="text"
      [formControl]="searchKeyAccount"
    />
    <div class="input-group-icon">
      <i
        (click)="clearSearchText()"
        *ngIf="searchKeyAccount.value"
        class="fa fa-times"
      ></i>
      <i *ngIf="!searchKeyAccount.value" class="pi pi-search"></i>
    </div>
    <div
      *ngIf="
        isFormSubmitted &&
        data?.rowData?.type !== 'onboard_user' &&
        selectedEditKeyAccounts.length === 0
      "
      class="error-block"
    >
      <p style="margin: 0">{{ 'ADMIN.PLEASE_SELECT_KEY_ACCOUNT' | translate }}</p>
    </div>
  </div>
  <div class="key-accounts-block">
    <span>
      <p class="sub-heading">{{ 'ADMIN.ASSIGN_KEY_ACCOUNT' | translate }}</p>
      <ul *ngIf="filteredKeyAccounts.length > 0; else noKeyAccounts">
        <li *ngFor="let keyAccount of filteredKeyAccounts">
          <p-checkbox
            class="key-account-label"
            [value]="keyAccount"
            [(ngModel)]="selectedEditKeyAccounts"
            [label]="keyAccount.name"
            styleClass="ka-checkbox"
          ></p-checkbox>
          <p class="country-region">
            {{ keyAccount.country }} | {{ keyAccount.region }}
          </p>
        </li>
      </ul>
      <ng-template #noKeyAccounts>
        <ul>
          <li style="text-align: center; font-size: 12px; font-weight: 600">
            {{ 'ADMIN.NO_KEY_ACCOUNTS_FOUND' | translate }}
          </li>
        </ul>
      </ng-template>
    </span>
  </div>
</div>

<!-- add edit key accounts -->
<div class="add-edit-key-account" *ngIf="data?.type === 'add_edit_key_account'">
  <div class="revoke-key-account" *ngIf="revokeKeyAccounts">
    <div class="confirm-message">
      {{ 'ADMIN.REVOKE_KA_UNSELECTED_MSG' | translate }}
    </div>
  </div>
  <div *ngIf="!revokeKeyAccounts">
    <div class="search-input-group">
      <input
        [placeholder]="'ADMIN.SEARCH_KA_PLACEHOLDER' | translate"
        class="form-control"
        type="text"
        [formControl]="searchKeyAccount"
        (click)="addNewKeyAccount = true"
        (blur)="addNewKeyAccount = false"
      />
      <div class="input-group-icon">
        <i
          (click)="clearSearchText()"
          *ngIf="searchKeyAccount.dirty"
          class="fa fa-times"
        ></i>
        <i *ngIf="!searchKeyAccount.dirty" class="pi pi-search"></i>
      </div>
    </div>
    <div class="key-accounts-block">
      <span
        *ngIf="data?.rowData?.key_accounts.length > 0"
        class="{{
          addNewKeyAccount ? 'hide-added-key-accounts' : 'added-key-accounts'
        }}"
      >
        <p class="sub-heading">
          {{ data?.rowData?.key_accounts.length }} {{ 'ADMIN.KEY_ACCOUNTS_ADDED' | translate }}
        </p>
        <ul>
          <li *ngFor="let keyAccount of data?.rowData?.key_accounts">
            <p-checkbox
              class="key-account-label"
              [(ngModel)]="existingKeyAccounts"
              [value]="keyAccount"
              [label]="keyAccount.name"
            ></p-checkbox>
            <p class="country-region">
              {{ keyAccount.country }} | {{ keyAccount.region }}
            </p>
          </li>
        </ul>
      </span>
      <span>
        <p class="sub-heading">{{ 'ADMIN.ADD_NEW_KEY_ACCOUNT' | translate }}</p>
        <ul *ngIf="filteredKeyAccounts.length > 0; else noKeyAccounts">
          <li *ngFor="let keyAccount of filteredKeyAccounts">
            <p-checkbox
              class="key-account-label"
              [value]="keyAccount"
              [(ngModel)]="selectedEditKeyAccounts"
              [label]="keyAccount.name"
            ></p-checkbox>
            <p class="country-region">
              {{ keyAccount.country }} | {{ keyAccount.region }}
            </p>
          </li>
        </ul>
        <ng-template #noKeyAccounts>
          <ul>
            <li style="text-align: center; font-size: 12px; font-weight: 600">
              {{ 'ADMIN.NO_KEY_ACCOUNTS_FOUND' | translate }}
            </li>
          </ul>
        </ng-template>
      </span>
    </div>
  </div>
</div>

<!-- approve user request -->
<div class="approve-request" *ngIf="data?.type === 'approve_request'">
  <div class="search-input-group">
    <input
      [placeholder]="'ADMIN.SEARCH_KA_PLACEHOLDER' | translate"
      class="form-control"
      type="text"
      [formControl]="searchKeyAccount"
      (click)="addNewKeyAccount = true"
      (blur)="addNewKeyAccount = false"
    />
    <div class="input-group-icon">
      <i
        (click)="clearSearchText()"
        *ngIf="searchKeyAccount.dirty"
        class="fa fa-times"
      ></i>
      <i *ngIf="!searchKeyAccount.dirty" class="pi pi-search"></i>
    </div>
  </div>
  <div
    *ngIf="
      isFormSubmitted &&
      data?.rowData?.type === 'add_keyaccount' &&
      selectedEditKeyAccounts.length === 0
    "
    class="error-block"
  >
    <p>{{ 'ADMIN.PLEASE_SELECT_KEY_ACCOUNT' | translate }}</p>
  </div>
  <div class="key-accounts-block">
    <div class="key-account-wrapper">
     <span>
     <mat-checkbox type="checkbox" class="key-account-checkbox" [(ngModel)]="selectAllKeyAccounts" (change)="selectAllAccounts()"> </mat-checkbox>
     </span>
     <span class="sub-heading">{{ 'ADMIN.SELECT_ALL' | translate }}</span>
    </div>
   
     <ul>
       <li *ngFor="let keyAccount of filteredKeyAccounts">
         <p-checkbox
           class="key-account-label"
           [value]="keyAccount"
           [(ngModel)]="selectedEditKeyAccounts"
           [label]="keyAccount.name"
           styleClass="ka-checkbox"
         ></p-checkbox>
         <p class="country-region">
           {{ keyAccount.country }} | {{ keyAccount.region }}
         </p>
       </li>
     </ul>
     <ul *ngIf="filteredKeyAccounts.length === 0">
       <li style="text-align: center; font-weight: 600; font-size: 12px">
         {{ 'ADMIN.NO_KEY_ACCOUNTS_FOUND' | translate }}
       </li>
     </ul>
   </div>
 
</div>

<!-- reject user request -->
<div class="reject-request" *ngIf="data?.type === 'reject_request'">
  <div [ngClass]="{ 'error-form-field': !rejectReason && isFormSubmitted }">
    <p class="label">{{ 'ADMIN.REASON' | translate }}</p>
    <textarea
      [placeholder]="'ADMIN.TYPE_HERE' | translate"
      cols="30"
      rows="5"
      class="form-control"
      name="reason"
      [(ngModel)]="rejectReason"
    ></textarea>
    <div *ngIf="!rejectReason && isFormSubmitted">
      <p>{{ 'ADMIN.REASON_REQUIRED' | translate }}</p>
    </div>
  </div>
</div>

<!-- clone experiment -->
<div class="clone-experiment" *ngIf="data?.type === 'clone_exp'">
  <p>{{ 'ADMIN.EXPERIMENT_NAME' | translate }}</p>
  <input type="text" class="form-control" />
</div>

<!-- delete experiment -->
<div class="delete-experiment" *ngIf="data?.type === 'delete_exp'">
  <p>
    {{ 'ADMIN.DELETE_EXPERIMENT_MSG' | translate }} <b>{{ data?.rowData?.name }}</b> {{ 'ADMIN.EXPERIMENT_SUFFIX' | translate }}
  </p>
</div>

<!-- delete zone -->
<div class="delete-experiment" *ngIf="data?.type === 'appRevokeZone'">
  <p>
    {{ 'ADMIN.DELETE_ZONE_MSG' | translate }} <b>{{ data?.rowData?.name }}</b> {{ 'ADMIN.ZONE_SUFFIX' | translate }}
  </p>
</div>
<!-- delete key account -->
<div class="delete-experiment" *ngIf="data?.type === 'delete_key_account'">
  <p>
    {{ 'ADMIN.DELETE_KA_MSG' | translate }} <b>{{ data?.rowData?.name }}</b> {{ 'ADMIN.KEY_ACCOUNT_SUFFIX' | translate }}
  </p>
</div>

<!-- delete plan -->
<div class="delete-experiment" *ngIf="data?.type === 'delete_plan'">
  <p>{{ 'ADMIN.DELETE_PLAN_MSG' | translate }}</p>
  <p class="delete-plan-note">{{ 'ADMIN.DELETE_PLAN_NOTE' | translate }}</p>
</div>

<!-- skip golden rule -->
<div class="delete-experiment" *ngIf="data?.type === 'skip_golden_rule'">
  <p>{{ 'ADMIN.SKIP_GOLDEN_RULE_MSG' | translate }}</p>
  <p>{{ 'ADMIN.CONFIRM_CONTINUE' | translate }}</p>
</div>

<!-- share experiment -->
<div class="share-experiment" *ngIf="data?.type === 'share_exp'">
  <div
    class="share-search-input-group"
    [ngClass]="{
      'error-autocomplete':
        (isFormSubmitted &&
          shareAutocomplete.touched &&
          !shareAutocomplete.dirty) ||
        (isFormSubmitted &&
          emailIdsList.length === 0 &&
          shareAutocomplete.dirty)
    }"
  >
    <p-autoComplete
      [formControl]="shareAutocomplete"
      [suggestions]="emailIdsList"
      (completeMethod)="searchMailIds($event)"
      field="name"
      appendTo="body"
      styleClass="share-exp-autocomplete"
      panelStyleClass="share-exp-autocomplete-panel"
      [placeholder]="'ADMIN.TYPE_TO_SEARCH_ADD_USER' | translate"
      multiple
      fluid
      separator=","
      [(ngModel)]="validUserList"
    >
      <ng-template let-data pTemplate="item">
        <div
          class="flex align-items-center gap-2 email-list-item"
          [ngClass]="{
            'disabled-auto-complete-suggestion': !data.has_key_account_access
          }"
          (click)="data.has_key_account_access ? '' : $event.stopPropagation()"
        >
          <p class="email-user-name">{{ data.name }}</p>
          <p class="email-id-name">{{ data.email }}</p>
          <p *ngIf="!data.has_key_account_access" class="email-error">
            {{ 'ADMIN.USER_LACKS_KA_ACCESS' | translate }}
          </p>
        </div>
      </ng-template>
      <ng-template let-item pTemplate="selectedItem">
        <span class="custom-chip" [ngClass]="{ 'invalid-chip': !item.has_key_account_access }">
          {{ item.name }}
        </span>
      </ng-template>
    </p-autoComplete>
    <div class="error-block">
      <p
        *ngIf="
          isFormSubmitted &&
          shareAutocomplete.touched &&
          !shareAutocomplete.dirty
        "
      >
        {{ 'ADMIN.TYPE_SELECT_FROM_LIST' | translate }}
      </p>
      <p
        *ngIf="
          isFormSubmitted &&
          validUserList.length === 0 &&
          shareAutocomplete.dirty
        "
      >
        {{ 'ADMIN.ENTERED_VALUE_INVALID' | translate }}
      </p>
    </div>
    <div class="input-group-icon">
      <i
        (click)="clearSearchText()"
        *ngIf="isShareSearchInput"
        class="fa fa-times"
      ></i>
      <i
        *ngIf="!isShareSearchInput && shareAutocomplete.dirty"
        class="pi pi-search"
      ></i>
    </div>
  </div>
  <div class="share-btn-block">
    <p class="sub-heading">
      <p-checkbox
        styleClass="share-experiment-checkbox"
        [(ngModel)]="allowExperimentEditing"
        [binary]="true"
      ></p-checkbox>
      {{ 'ADMIN.ALLOW_EDITING' | translate }}
    </p>
    <button
      *ngIf="!showSpinner"
      class="btn share-btn"
      (click)="shareExperiment()"
      [disabled]="areAllValidUser()"
    >
      {{ 'ADMIN.SHARE' | translate }}
    </button>
    <button *ngIf="showSpinner" class="btn share-btn">
      <mat-spinner
        style="left: 1em"
        strokeWidth="1"
        diameter="16"
        color="#000000"
        *ngIf="showSpinner"
      ></mat-spinner>
    </button>
  </div>
  <p class="shared-with">{{ 'ADMIN.SHARED_WITH' | translate }}</p>
  <ul *ngIf="sharedUsers.length > 0 && !isApiCalling">
    <li *ngFor="let user of sharedUsers; let i = index">
      <div class="row">
        <div class="col-1">
          <span
            class="name-icon"
            *ngIf="user.first_name || user.last_name"
            [ngStyle]="{ 'background-color': getColor(i) }"
          >
            {{ user.first_name ? user.first_name[0] : ""
            }}{{ user.last_name ? user.last_name[0] : "" }}
          </span>
          <span
            class="name-icon"
            *ngIf="!user.first_name && !user.last_name"
            [ngStyle]="{ 'background-color': getColor(i) }"
          >
            {{ user.email[0] | uppercase }}
          </span>
        </div>
        <div class="col-3">
          <span *ngIf="user.first_name" class="name"
            >{{ user.first_name }} {{ user.last_name }}</span
          >
          <span *ngIf="!user.first_name" class="name">{{ user.email }}</span>
          <br />
          <span class="email">{{ user.email }}</span>
        </div>
        <div class="col-6 can-view">
          <p-dropdown
            [placeholder]="'ADMIN.CAN_VIEW' | translate"
            appendTo="body"
            styleClass="can-view-options-dropdown"
            panelStyleClass="can-view-options-dd-panel"
            optionDisabled="inactive"
            [options]="canViewOptions"
            [(ngModel)]="user.permission"
            (onChange)="onChangeShareOptions($event, user)"
          >
            <ng-template let-option pTemplate="item">
              <div class="row">
                <span class="col-3">
                  <i
                    *ngIf="
                      user.permission === option.value &&
                      option.value !== 'Remove'
                    "
                    class="fa fa-check"
                  ></i>
                </span>
                <span class="col-9" style="width: 70%; text-align: left">{{
                  option.value
                }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </li>
  </ul>
  <ul *ngIf="sharedUsers.length === 0 && !isApiCalling">
    <li style="text-align: center; font-weight: 600; font-size: 12px">
      {{ 'ADMIN.NO_SHARED_USERS_FOUND' | translate }}
    </li>
  </ul>
  <div class="row" *ngIf="isApiCalling">
    <div class="col-1">
      <p-skeleton shape="circle" size="2rem" styleClass="mr-2"></p-skeleton>
    </div>
    <div class="col-3">
      <p-skeleton width="6rem" height="1rem" styleClass="mb-2"></p-skeleton>
      <p-skeleton width="9rem" height="1rem" styleClass="mb-2"></p-skeleton>
    </div>
    <div class="col-6">
      <p-skeleton
        width="3rem"
        height="1rem"
        styleClass="mb-2 can-view-skeleton"
      ></p-skeleton>
    </div>
  </div>
</div>

<div class="experiment-details" *ngIf="data?.type === 'exp_details'">
  <div class="row">
    <div class="col-6">
      <label for="">{{ 'ADMIN.EXP_PLANOGRAM_SIZE' | translate }}</label>
      <p>123</p>
      <label for="">{{ 'ADMIN.EXP_TRAFFIC_FLOW' | translate }}</label>
      <p>Left to Right</p>
      <label for="">{{ 'ADMIN.EXP_NUMBER_OF_PLANS' | translate }}</label>
      <p>4</p>
    </div>
    <div class="col-6">
      <label for="">{{ 'ADMIN.EXP_NUMBER_OF_DOORS' | translate }}</label>
      <p>cccc</p>
      <label for="">{{ 'ADMIN.EXP_NUMBER_OF_SKUS' | translate }}</label>
      <p>350</p>
      <label for="">{{ 'ADMIN.EXP_LAST_UPDATE' | translate }}</label>
      <p>02 Mar 2023, 01:23PM</p>
    </div>
  </div>
</div>

<!-- app settings edit zone -->
<div
  [formGroup]="addEditZoneFormGroup"
  class="app-edit-zone"
  *ngIf="data?.type === 'app_edit_zone'"
>
  <div class="input-elm">
    <p>{{ 'ADMIN.ZONE' | translate }}</p>
    <input type="text" formControlName="zone" class="form-control" />
  </div>
  <div
    *ngIf="
      addEditZoneFormGroup?.controls?.zone?.errors?.required && isFormSubmitted
    "
  >
    <p class="error-text">{{ 'ADMIN.ZONE_NAME_REQUIRED' | translate }}</p>
  </div>
</div>

<!-- system config add new key account -->
<div
  class="system-config-key-account"
  *ngIf="
    data?.type === 'app_add_key_account' || data?.type === 'edit_key_account'
  "
>
  <div [formGroup]="addKeyAccFormGroup">

    <div *ngIf="data?.type === 'app_add_key_account'" class="input-elm">
      <label for="">{{ 'ADMIN.ZONE' | translate }}</label>
      <p-dropdown
        appendTo="body"
        [options]="data?.zones"
        optionLabel="name"
        optionValue="id"
        [placeholder]="'ADMIN.SELECT_ZONE' | translate"
        styleClass="add-user-dropdown"
        panelStyleClass="add-user-dropdown-panel"
        formControlName="zone_id"
      >
      </p-dropdown>
      <p
        class="error-text"
        *ngIf="
          isFormSubmitted &&
          addKeyAccFormGroup?.controls?.zone_id?.errors?.required
        "
      >
        {{ 'ADMIN.PLEASE_SELECT_ZONE' | translate }}
      </p>
    </div>

    <div class="input-elm">
      <label for="">{{ 'ADMIN.REGION' | translate }}</label>
      <p-dropdown
        appendTo="body"
        [options]="data?.regions"
        [placeholder]="'ADMIN.SELECT_REGION' | translate"
        styleClass="add-user-dropdown"
        panelStyleClass="add-user-dropdown-panel"
        formControlName="region"
        (onChange)="onRegionChange($event)"
      >
      </p-dropdown>

        <input
          type="text"
          [hidden]="selectedRegion != 'Other' && data?.type === 'app_add_key_account'"
          class="form-control"
          formControlName="otherRegion"
          [placeholder]="'ADMIN.ENTER_REGION_NAME' | translate"
          style="margin-top: 8px"
          #otherRegionInput
        />

      <p
        class="error-text"
        *ngIf="
          isFormSubmitted &&
          addKeyAccFormGroup?.controls?.region?.errors?.required
        "
      >
        {{ 'ADMIN.REGION_REQUIRED' | translate }}
      </p>
    </div>
    <div class="input-elm">
      <label for="">{{ 'ADMIN.COUNTRY' | translate }}</label>
      <p-dropdown
        appendTo="body"
        [options]="data?.countries"
        [placeholder]="'ADMIN.SELECT_COUNTRY' | translate"
        styleClass="add-user-dropdown"
        panelStyleClass="add-user-dropdown-panel"
        formControlName="country"
        (onChange)="onCountryChange($event)"
      >
      </p-dropdown>

        <input
          type="text"
          [hidden]="selectedCountry != 'Other' && data?.type === 'app_add_key_account'"
          class="form-control"
          formControlName="otherCountry"
          [placeholder]="'ADMIN.ENTER_COUNTRY_NAME' | translate"
          style="margin-top: 8px"
          #otherCountryInput
        />
      <p
        class="error-text"
        *ngIf="
          isFormSubmitted &&
          addKeyAccFormGroup?.controls?.country?.errors?.required
        "
      >
        {{ 'ADMIN.COUNTRY_REQUIRED' | translate }}
      </p>
    </div>
    <div class="input-elm">
      <label for="">{{ 'ADMIN.KEY_ACCOUNT' | translate }}</label>
      <input
        type="text"
        class="form-control"
        formControlName="name"
        [placeholder]="'ADMIN.ENTER_KA' | translate"
      />
      <p
        class="error-text"
        *ngIf="
          isFormSubmitted &&
          addKeyAccFormGroup?.controls?.name?.errors?.required
        "
      >
        {{ 'ADMIN.KA_NAME_REQUIRED' | translate }}
      </p>
    </div>
    <div *ngIf="data?.type === 'edit_key_account'" class="input-elm">
      <label for="">{{ 'ADMIN.ZONE' | translate }}</label>
      <p-dropdown
        appendTo="body"
        [options]="data?.zones"
        optionLabel="name"
        optionValue="id"
        [placeholder]="'ADMIN.SELECT_ZONE' | translate"
        styleClass="add-user-dropdown"
        panelStyleClass="add-user-dropdown-panel"
        formControlName="zone_id"
        [readonly]="true"
      >
      </p-dropdown>
      <p
        class="error-text"
        *ngIf="
          isFormSubmitted &&
          addKeyAccFormGroup?.controls?.zone_id?.errors?.required
        "
      >
        {{ 'ADMIN.PLEASE_SELECT_ZONE' | translate }}
      </p>
    </div>
  </div>
</div>

<div *ngIf="errMessage" class="error-block pt-1">
  <p>{{ errMessage }}</p>
</div>

<!-- common buttons for all dialogs -->
<div
  class="dialog-footer pt-3 p-dialog-footer"
  *ngIf="data?.type !== 'share_exp'"
>
  <button
    *ngIf="data?.cancelBtn"
    [ngClass]="{
      'add-user-btn': data?.type === 'add_user',
      'add-edit-key-accounts-btn': data?.type === 'add_edit_key_account'
    }"
    class="btn cancel-btn mr-2"
    (click)="closeDialog()"
  >
    {{ data?.cancelBtn | translate }}
  </button>
  <button
    *ngIf="data?.okBtn && !isApiCalling"
    [ngClass]="{
      'add-user-btn': data?.type === 'add_user',
      'add-edit-key-accounts-btn': data?.type === 'add_edit_key_account'
    }"
    class="btn ok-btn"
    (click)="submitDialog()"
  >
    {{ data?.okBtn | translate }}
  </button>
  <button *ngIf="data?.okBtn && isApiCalling" class="btn ok-btn">
    <mat-spinner
      style="left: 1.6em"
      strokeWidth="1"
      diameter="16"
      color="#000000"
      *ngIf="isApiCalling"
    ></mat-spinner>
  </button>
</div>
